(() => {
  const placeExperienceEntry = () => {
    const entry = document.querySelector('.pr3dnh-pdp-entry');
    const details = document.querySelector('main[data-template^="product"] .product-details');
    const form = details?.querySelector('form[action*="/cart/add"]');
    const buyArea = form?.closest('buy-buttons-block, .buy-buttons-block') || form;
    if (entry && buyArea && entry.previousElementSibling !== buyArea) {
      buyArea.insertAdjacentElement('afterend', entry);
    }
  };

  const selectedVariantId = () => {
    const checked = [...document.querySelectorAll('variant-picker input[type="radio"]:checked[data-variant-id]')].reverse().find((node) => node.dataset.variantId);
    return String(checked?.dataset.variantId || document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || '');
  };

  const syncExperienceLink = () => {
    const link = document.querySelector('[data-pr3dnh-experience-link]');
    if (!link) return;
    const url = new URL(link.getAttribute('href') || '/products/ganesh-chalisa-hindi?gnh3d=1&from=product', location.origin);
    const variantId = selectedVariantId();
    if (variantId) url.searchParams.set('variant', variantId);
    else url.searchParams.delete('variant');
    link.href = `${url.pathname}${url.search}${url.hash}`;
  };

  placeExperienceEntry();
  syncExperienceLink();

  if (window.__pr3dnhAftercareReady) return;
  window.__pr3dnhAftercareReady = true;

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(() => {
    placeExperienceEntry();
    syncExperienceLink();
  }));

  document.addEventListener('change', (event) => {
    if (event.target?.closest?.('variant-picker')) requestAnimationFrame(syncExperienceLink);
  });

  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('[data-pr3dnh-experience-link]');
    if (!link) return;
    syncExperienceLink();
  }, true);

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.data?.didError) return;
    if (sessionStorage.getItem('pr3dnh_opened_ganesh_hindi') !== '1') return;
    if (sessionStorage.getItem('pr3dnh_cart_after_tracked') === '1') return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart_after_3d_experience',
      pr3dnh: true,
      experience: 'hindi_ganesh_gift_set_v12',
      product_handle: 'ganesh-chalisa-hindi',
      variant_id: selectedVariantId(),
      completed: sessionStorage.getItem('pr3dnh_completed_ganesh_hindi') === '1'
    });
    sessionStorage.setItem('pr3dnh_cart_after_tracked', '1');
  });
})();

